import Vue from 'vue'
Vue.api = Vue.prototype.$api = {
  queryProjectInfo: "/app-service/project/queryProjectInfo", // 获取详情
  getEmailSetting: "/app-service/agent/queryShareAgentInfo", // 获取经纪人
  queryProjectMedia: "/app-service/media/queryProjectShareMedia", // 获取图片
  querySysConfig: "/app-service/config/querySysConfig", // 系统配置
  getUnitInfo: "/trade-service/unit/getUnitInfo", // 获取Unit
  unitTypeReport: "/app-service/unit/unitTypeReport", // 详情统计数据
  queryAgentProjectList: "/app-service/project/queryAgentProjectList", // 经纪人项目
  sendEmailToAgent: "/app-service/email/sendEmailToAgent", // 发送邮件
  querySitePlanImg: "/app-service/siteplan/querySitePlanImg", // 查询sitePlan
  queryUnitType: "/app-service/floor/queryUnitType", // 查询项目所有户型
  queryFloorPlansByType: "/app-service/floor/queryFloorPlansByType", //查询floor plans户型图列表
  queryAppointmentShare: "/app-service/appointment/queryAppointmentShare", // 查询预约分享信息
  shareSearchList: "/app-service/project/shareSearchList", // 推荐信息
  getShareParams: "/app-service/share/getShareParams", //查询分享参数
  queryProjectListByShare: "/app-service/project/queryProjectListByShare", //查询筛选分享列表
  getMediaLink: "/app-service/share/getMediaLink", //查询media链接
  getPdfLink: "/app-service/share/getPdfLink", //查询pdf链接
  getFloorPlanLink: "/app-service/share/getFloorPlanLink", //查询floor plan链接
  queryProjectInfoByComparison: '/app-service/other/queryProjectInfoByComparison', //查询Other项目详情
  getProjectSetById: "/app-service/project/getProjectSetById", // 项目设置
}


// WEBPACK FOOTER //
// ./src/config/api.js